import "./App.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Layout from "./components/Layout";

function App() {
  return (
    <>
      <Navbar />
      <Layout />
      <Footer />
    </>
  );
}

export default App;
